module.exports = __webpack_public_path__ + "img/logo_yadi.9d07683f.png";